// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2zeW5","tab":"Tabs_tab__2Gn0p","tabActive":"Tabs_tabActive__fjwQD"};